import { Talent } from "../../Classes";

const tier4 = [
  new Talent(
    "Arctic Reach",
    "spell_shadow_darkritual",
    [
      "Increases the range of your Frostbolt and Blizzard spells and the radius of your Frost Nova and Cone of Cold spells by ",
      "%.",
    ],
    2,
    [[10, 20]],
  ),
  new Talent(
    "Frost Channeling",
    "spell_frost_stun",
    [
      "Reduces the mana cost of your Frost Spells by ",
      "% and reduces the threat generated by your Frost spells by ",
      "%.",
    ],
    3,
    [
      [5, 10, 15],
      [10, 20, 30],
    ],
  ),
  new Talent(
    "Shatter",
    "spell_frost_frostshock",
    [
      "Increases the critical strike chance of all your spells against frozen targets by ",
      "%.",
    ],
    2,
    [[25, 50]],
    [{ x: 1, y: 2 }],
    null,
    null,
    null,
    null,
    null,
    null,
    {
      isNew: false,
      isChanged: true,
      isMoved: false,
    },
  ),
  new Talent(
    "Piercing Chill",
    "spell_frost_piercing-chill",
    [
      "Gives your Forstbolt a ",
      "% chance to apply the chill effect to a nearby target.",
    ],
    2,
    [[50, 100]],
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    { isNew: true, isChanged: false, isMoved: false },
  ),
];

export default tier4;
